import QRCode from "react-qr-code";
import { Box, Typography } from "@mui/material";
import React from "react";

const ResponsiveQRCode = ({ value }: { value: string }) => {
  // Debug: Log the value being passed
  console.log("QR Code value:", value);
  console.log("QR Code value type:", typeof value);
  console.log("QR Code value length:", value?.length);

  if (!value) {
    return (
      <Box
        sx={{
          width: "240px",
          height: "240px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f5f5f5",
          borderRadius: "12px",
          color: "text.secondary",
        }}
      >
        <Typography variant="body2">No URI available</Typography>
      </Box>
    );
  }

  try {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "240px",
          height: "240px",
          padding: "16px",
          backgroundColor: "#ffffff",
          borderRadius: "12px",
          boxShadow: "0 2px 12px rgba(0, 0, 0, 0.08)",
          border: "1px solid rgba(0, 0, 0, 0.06)",
        }}
      >
        <QRCode value={value} size={200} level="L" fgColor="#000000" bgColor="#ffffff" />
      </Box>
    );
  } catch (error) {
    console.error("Error rendering QR code:", error);
    return (
      <Box
        sx={{
          width: "240px",
          height: "240px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f5f5f5",
          borderRadius: "12px",
          color: "text.secondary",
        }}
      >
        <Typography variant="body2">Error rendering QR code</Typography>
      </Box>
    );
  }
};

export default ResponsiveQRCode;
